<template>
	<ConfirmationDialog class="delete-goal-prompt">
		<template #header>
			<h1 class="delete-goal-prompt__heading">{{ $t( "common-gokr.components.DeleteGoalPrompt.title" ) }}</h1>
		</template>
		<template #description>
			<main class="delete-goal-prompt__main">
				{{ $t( "common-gokr.components.DeleteGoalPrompt.description" ) }}
			</main>
		</template>
		<template #actions>
			<footer class="delete-goal-prompt__footer">
				<TeamingButton
					size="SMALL"
					type="PRIMARY"
					:destructive="true"
					@click="$emit( `confirm` )"
				>
					{{ $t( "common-gokr.components.DeleteGoalPrompt.confirmButton" ) }}
				</TeamingButton>
				<TeamingButton
					size="SMALL"
					type="QUATERNARY"
					@click="$emit( `dismiss` )"
				>
					{{ $t( "common-gokr.components.DeleteGoalPrompt.dismissButton" ) }}
				</TeamingButton>
			</footer>
		</template>
	</ConfirmationDialog>
</template>

<script>
import { ConfirmationDialog, TeamingButton } from "@teaming/common-ui";
export default {
	name: "DeleteGoalPrompt",
	emits: [ "confirm", "save", "dismiss", ],
	components: {
		ConfirmationDialog,
		TeamingButton,
	},
};
</script>

<style lang="scss" scoped>
$delete-goal-prompt-title-color: $color1-700;

.delete-goal-prompt__heading {
	@include font-and-line-for(1);
	font-weight: 600;
	color: $delete-goal-prompt-title-color;
}

.delete-goal-prompt__footer {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 1rem;
}
</style>
